import { Routes, Route } from 'react-router-dom';
import React from 'react';
import { LocaleLayout } from './LocaleLayout';
import { marketingRoutes } from './marketingRoutes';

export function PublicRoutes() {
    return (
        <Routes>
            {/* English (canonical) — no prefix; LocaleLayout sees lang === undefined */}
            <Route path="/" element={<LocaleLayout/>}>
                {marketingRoutes()}
            </Route>
            {/* Localized: /:lang/* — LocaleLayout reads :lang and switches i18n */}
            <Route path="/:lang" element={<LocaleLayout/>}>
                {marketingRoutes()}
            </Route>
        </Routes>
    );
}
